import React from "react";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src="/assets/steadfast-logo.png"
    alt="Steadfast IT Consulting"
    className={className}
    data-testid="steadfast-logo"
  />
);

export const LogoLockup = ({ size = "md" }) => {
  const h = size === "lg" ? "h-20 w-20" : size === "sm" ? "h-8 w-8" : "h-12 w-12";
  const titleCls =
    size === "lg"
      ? "text-2xl md:text-3xl"
      : size === "sm"
      ? "text-sm"
      : "text-base md:text-lg";
  return (
    <div className="flex items-center gap-3" data-testid="logo-lockup">
      <LogoMark className={h} />
      <div className="leading-tight">
        <div className={`font-serif ${titleCls} tracking-tight`}>Steadfast</div>
        <div className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground">
          IT Consulting
        </div>
      </div>
    </div>
  );
};
